import React from 'react';
import { initialReminderFilters, ReminderContext, ReminderContextType } from '~/services';

const displayNames = {
    clinic: 'Clinic',
    PCP: 'PCP',
    dueDate: 'Due Date',
    byMe: 'Created By Me',
    statusOpen: 'Status: Open',
    statusInprogress: 'Status: In Progress',
    statusDone: 'Status: Done',
    statusNa: 'Status: N/A',
    statusMissed: 'Status: Missed',
    createdByTypeUser: 'Type: User Created',
    createdByTypeSystem: 'Type: Timely Action',
    openGaps: 'Open Gaps',
    warning: 'Warning',
    critical: 'Critical',
    measureCode: 'Action',
};
type DisplayNameKey = keyof typeof displayNames;

export function ReminderFilterBadges() {
    const { filterValues, setFilterValues, resetPagination, byMe, setCreatedByMe } =
        React.useContext(ReminderContext) as ReminderContextType;

    function remove(key: DisplayNameKey) {
        resetPagination();
        if (key === 'clinic') {
            setFilterValues((prev) => ({
                ...prev,
                clinic: [],
            }));
        } else if (key === 'PCP') {
            setFilterValues((prev) => ({
                ...prev,
                PCP: [],
            }));
        } else if (key === 'dueDate') {
            setFilterValues((prev) => ({
                ...prev,
                dueDateStart: initialReminderFilters.dueDateStart,
                dueDateEnd: initialReminderFilters.dueDateEnd,
            }));
        } else if (key === 'byMe') {
            setCreatedByMe(false);
        } else if (key.substring(0, 6) === 'status') {
            setFilterValues((prev) => ({
                ...prev,
                viewStatus:
                    prev.viewStatus.filter((status) => status !== key.substring(6).toLowerCase()) ||
                    null,
            }));
        } else if (key === 'createdByTypeUser' || key === 'createdByTypeSystem') {
            setFilterValues((prev) => ({
                ...prev,
                createdByType: null,
            }));
        } else if (key === 'openGaps') {
            setFilterValues((prev) => ({
                ...prev,
                hasOpenGap: false,
            }));
        } else if (key === 'critical' || key === 'warning') {
            setFilterValues((prev) => ({
                ...prev,
                priority: null,
            }));
        } else if (key === 'measureCode') {
            setFilterValues((prev) => ({
                ...prev,
                measureCode: [],
            }));
        }
    }

    function display(key: DisplayNameKey) {
        return (
            <span className="badge bg-primary badge-font-90 me-2 mb-3" key={key}>
                {displayNames[key]}
                <button type="button" className="ms-1 pe-0 icon-button" onClick={() => remove(key)}>
                    <i className="fa-solid fa-remove text-white">
                        <span className="sr-only">Remove</span>
                    </i>
                </button>
            </span>
        );
    }

    return (
        <div className="col">
            {filterValues.viewStatus.map((status) =>
                display(
                    `status${status.charAt(0).toUpperCase() + status.slice(1)}` as DisplayNameKey
                )
            )}
            {filterValues.clinic !== null && filterValues.clinic.length > 0 && display('clinic')}
            {filterValues.PCP !== null && filterValues.PCP.length > 0 && display('PCP')}
            {(filterValues.dueDateStart || filterValues.dueDateEnd) && display('dueDate')}
            {byMe && display('byMe')}
            {filterValues.hasOpenGap && display('openGaps')}
            {filterValues.priority === 'warning' && display('warning')}
            {filterValues.priority === 'critical' && display('critical')}
            {filterValues.createdByType &&
                display(
                    `createdByType${
                        filterValues.createdByType.charAt(0).toUpperCase() +
                        filterValues.createdByType.slice(1)
                    }` as DisplayNameKey
                )}
            {filterValues.measureCode !== null &&
                filterValues.measureCode.length > 0 &&
                display('measureCode')}
        </div>
    );
}
